// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import TextContentTranslationPagingResultModel from '../../model/text-content-translation-paging-result-model';
import TextContentTranslationPagingResultDTO from '../dto/text-content-translation-paging-result-dto';
import dtoSchema from '../schemas/text-content-translation-paging-result-schema';
import TextContentTranslationModel from '../../model/text-content-translation-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class TextContentTranslationPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<TextContentTranslationPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => TextContentTranslationModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: TextContentTranslationModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<TextContentTranslationPagingResultDTO>): TextContentTranslationPagingResultModel;
  static toModel(dto: DeepPartial<TextContentTranslationPagingResultDTO> | undefined | null): TextContentTranslationPagingResultModel | undefined;
  static toModel(dto: DeepPartial<TextContentTranslationPagingResultDTO> | undefined | null): TextContentTranslationPagingResultModel | undefined {
    return dto ? new TextContentTranslationPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<TextContentTranslationPagingResultModel> | TextContentTranslationPagingResultModel): TextContentTranslationPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as TextContentTranslationPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for TextContentTranslationPagingResultModel, can not map to TextContentTranslationPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
